import gql from 'graphql-tag';

export const GET_PRO = gql`
  query getPro($id: ID!) {
    pro(id: $id) {
      id
      uid
      sid
      image
      imageProfil
      additionalType
      address
      alternateName
      description
      geo
      packages
      schedule
      stats
      website
    }
  }
`;
